import { render, staticRenderFns } from "./ConsultationView.vue?vue&type=template&id=72601ecc"
import script from "./ConsultationView.vue?vue&type=script&lang=js"
export * from "./ConsultationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports